import { StyleRules } from '@material-ui/core/styles'

/** Layout and keyboard focus styles for pagination controls. */
const style = (): StyleRules<'pagination' | 'controls'> => ({
    pagination: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 16,
        width: '100%'
    },
    controls: {
        display: 'flex',
        gap: 8,
        marginLeft: 'auto',
        '& button:focus-visible': {
            outline: '2px solid currentColor',
            outlineOffset: 2
        }
    }
})

export default style
